// EBank entry point - imports main ebank files
// Ensure userData is always defined as an object
window.userData = window.userData || {};
import './safe-bootstrap.js';
import 'jquery';
import 'underscore';
import 'backbone';
import './views/views.js';
import './bootstrap.min.js';
import 'shepherd.js';
import './shared.js';
import './session-manager.js';
import './api-helper.js';
import './auth-modal.js';
import './material.min.js';
// vendor UMD libs are loaded via script tags in templates
import './data-accessor.js';
// bloodhound/typeahead loaded via script tags
import './autocomplete.js';
import './moderation.js';
import './file-upload.js';
import './signup.js';
import './string-utils.js';
import './cookie-utils.js';
import './dom-utils.js';
import './image-utils.js';
import './navigation-utils.js';
import './collection-utils.js';
import './template-utils.js';
import './auth-utils.js';
import './background-utils.js';
